var NumericInput = function(input) {
	this.input = $(input);
	this.prevVal = this.input.val();
	this.input.on('input', this.onInput.bind(this));
    this.input.on('wheel mousewheel DOMMouseScroll', function () { return false; });
}

NumericInput.prototype.onInput = function() {
    var maxlength = this.input.attr('maxlength');
	var val = this.input.val();
	if (this.input[0].validity.valid && (!maxlength || val.length <= maxlength) && (this.isNumeric(val) || val.length === 0)) {
	 	this.prevVal = this.input.val();
	} else {
		this.input.val(this.prevVal);
	}
}

NumericInput.prototype.isNumeric = function(val) {
	return !isNaN(parseInt(val, 10)) && isFinite(val);
}

$.fn.numericInput = function() {
    this.each(function(){
        new NumericInput(this);
    });
    return this;
}
